import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css']
})
export class LoginPageComponent implements OnInit {

  constructor() {}

  ngOnInit() {}

}



// WEBPACK FOOTER //
// ./src/app/login-page/login-page.component.ts